import React, { ChangeEvent, ComponentType, FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import classNames from 'classnames'
import { Radio, IRadioProps } from 'transfix-ui/components/Radio'
import { Box, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'

type IBaseControllerProps = ControllerProps<ComponentType<IRadioProps>>

export interface IControlledRadioDriverAssignationProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue' | 'value'> {
  RadioProps?: Omit<IRadioProps, 'onChange'>
  disabled?: boolean
}

const useStyles = makeStyles(theme => ({
  radioLabel: {
    '& .MuiTypography-body1': {
      ...theme.typography.subtitle2,
    },
  },
  disabled: {
    '& .MuiTypography-body2': {
      color: brandColors.coolGray4,
    },
  },
}))

const ControlledRadioDriverAssignation: FC<IControlledRadioDriverAssignationProps> = ({
  control,
  defaultValue,
  disabled = false,
  name,
}) => {
  const classes = useStyles()
  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
          onChange(value)
        }

        return (
          <div>
            <div className={classes.radioLabel}>
              <Radio
                label='Assign Driver Now'
                value='now'
                checked={value === 'now'}
                onChange={changeHandler}
                disabled={disabled}
                dataTest='sd-coverage-form-assign-driver-now'
              />
              <Box ml={4} className={classNames({ [classes.disabled]: disabled })}>
                <Typography variant='body2'>
                  Dispatcher has a driver assigned. Assign a driver and provide their ETA.
                </Typography>
              </Box>
            </div>
            <div className={classes.radioLabel}>
              <Radio
                className={classes.radioLabel}
                label='Assign Driver Later'
                value='later'
                checked={value === 'later'}
                onChange={changeHandler}
                disabled={disabled}
                dataTest='sd-coverage-form-assign-driver-later'
              />
              <Box ml={4} className={classNames({ [classes.disabled]: disabled })}>
                <Typography variant='body2'>
                  Dispatcher does not have driver assigned. Set a reminder.
                </Typography>
              </Box>
            </div>
          </div>
        )
      }}
    />
  )
}

export default ControlledRadioDriverAssignation
